// extracted by mini-css-extract-plugin
export default {"topTip":"src-pages-Settings-3rdPartyApi-css-module__topTip--3pbiF","contentLeft":"src-pages-Settings-3rdPartyApi-css-module__contentLeft--1o8uQ"};